module.exports = __webpack_public_path__ + "static/media/hero__team-details.138f65cf.jpg";